// extracted by mini-css-extract-plugin
module.exports = {"overviewInfo":"assets_overviewInfo_3XOdf","assets":"assets_assets_37ItC","assetsOverviewList":"assets_assetsOverviewList_2wN_u"};